import { FC } from 'react'
import { importApi } from '../../services/import.api'
import DonutChart from './DonutChart'

const TrackingChart: FC = () => {
  const { data } = importApi.useGetStatisticsQuery({})

  return !data?.trackingQueueAmount /* || !data?.trackingQueueTasksAmount*/ ? null : (
    <DonutChart
      title={<div className=' text-primary tracking-wide'>UPDATE</div>}
      autoPrefix
      data={[
        {
          // name: 'Errors',
          value: data?.trackingQueueErrorsAmount || 0,
          fill: 'var(--color-red-400)',
        },
        {
          // name: 'Passed',
          value:
            (data?.trackingQueueAmount || 0) -
            (data?.trackingQueueTasksAmount || 0) -
            (data?.trackingQueueErrorsAmount || 0),
          fill: 'var(--color-gray-300)',
          fillContrast: 'black',
        },
        {
          // name: 'All Tasks',
          value: data?.trackingQueueTasksAmount || 0,
          fill: 'var(--color-primary_hover)',
        },
      ]}
    />
  )
}

export default TrackingChart
